(function() {
    'use strict';

    angular
        .module('verificadocumentoApp')
        .controller('TituloElectronicoAngDialogController', TituloElectronicoAngDialogController);

    TituloElectronicoAngDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TituloElectronico'];

    function TituloElectronicoAngDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TituloElectronico) {
        var vm = this;

        vm.tituloElectronico = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tituloElectronico.id !== null) {
                TituloElectronico.update(vm.tituloElectronico, onSaveSuccess, onSaveError);
            } else {
                TituloElectronico.save(vm.tituloElectronico, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('verificadocumentoApp:tituloElectronicoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
